import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';

const EnquiriesTable = ({ handleCategoryPageChange, handlePageChange  }) => {
  const { enquiries_list, currentPage, totalPages } = useSelector((state) => state.admin_enquiries);

  return (
    <>
    <div className="table-responsive">
      <table className="table table-striped table-users table-alex text-center printarea">
                    <thead>
                      <tr>
                        <th className="text-start">Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Message</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {enquiries_list.length > 0 ? (
                        enquiries_list.map((enq) => (
                          <tr key={enq.id}>
                            <td className="text-start">{enq.first_name || ''} {enq.last_name || ''} </td>
                            <td>{enq.email || 'N/A'}</td>
                            <td>{enq.phone || 'N/A'}</td>
                            <td>{enq.message || 'N/A'}</td>
                            <td>{enq.created_at_display || 'N/A'}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: 'center' }}>No enquiries found.</td>
                        </tr>
                      )}
                    </tbody>
      </table>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      </>
  );
};
export default EnquiriesTable;